import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import PlaidLink from 'react-plaid-link';

class PlaidWidget extends PureComponent {
	render() {
		const {
			env, public_key, product, language, onSuccess, onExit,
		} = this.props;

		return (
			<div className="media" id="plaid-wrapper">
				<PlaidLink
					clientName="RollKall"
					env={env}
					product={product}
					publicKey={public_key} // eslint-disable-line camelcase
					onExit={onExit}
					onSuccess={onSuccess}
					language={language}
				>
					<div className="media-left media-middle">
						<div className="media-object">
							<i className="glyphicon glyphicon-link" />

						</div>
					</div>
					<div className="media-right media-body media-middle">
						<div className="h4 media-heading"><strong>Link Bank Account</strong></div>
						<span className="text-muted">Sign in to your bank account using your credentials</span>
					</div>
				</PlaidLink>
			</div>
		);
	}
}

PlaidWidget.propTypes = {
	env        : PropTypes.string.isRequired,
	public_key : PropTypes.string.isRequired, // eslint-disable-line camelcase
	onSuccess  : PropTypes.func.isRequired,
	onExit     : PropTypes.func,
	product    : PropTypes.array,
	language   : PropTypes.string,
};

PlaidWidget.defaultProps = {
	product  : ['auth'],
	language : 'en',
	onExit   : () => undefined,
};

export default PlaidWidget;
